import React, { type FC } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { getNav4Rollout } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-nav4-rollout/index.tsx';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useEffectWithoutConcurrency } from '@atlassian/jira-react-strict-mode/src/useEffectWithoutConcurrency.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

export const Nav4RolloutAnalytics: typeof Nav4RolloutAnalyticsWithoutErrorBoundary = (props) => (
	<JSErrorBoundary
		id="nav4-rollout-analytics"
		fallback="unmount"
		packageName={PACKAGE_NAME}
		teamName={TEAM_NAME}
	>
		<Nav4RolloutAnalyticsWithoutErrorBoundary {...props} />
	</JSErrorBoundary>
);

export const Nav4RolloutAnalyticsWithoutErrorBoundary: FC = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	// This should only run once. Fix for https://jplat.atlassian.net/browse/BLU-5516
	// and for React Concurrent.
	useEffectWithoutConcurrency(() => {
		const nav4Rollout = getNav4Rollout();

		if (nav4Rollout.stage !== 'none') {
			fireTrackAnalytics(createAnalyticsEvent({}), 'topNav viewed', nav4Rollout);
		}
	}, [createAnalyticsEvent]);

	return null;
};
